import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { saveLoginReferrer } from 'utils/loginReferrer';
import { AUTH } from 'helpers/routes';

interface RootState {
  auth: {
    authenticated: boolean;
  };
}

interface RequireAuthProps {
  children: React.ReactNode;
}

const RequireAuth: React.FC<RequireAuthProps> = ({ children }) => {
  const authenticated = useSelector((state: RootState) => state.auth.authenticated);
  const location = useLocation();

  if (!authenticated) {
    saveLoginReferrer(location.pathname + location.search);
    return <Navigate to={AUTH.login} replace />;
  }

  return <>{children}</>;
};

export default RequireAuth;
